import { CUSTOM_AUTHENTICATION_FACTOR_REQUIREMENT_REF_PREFIX } from './requirementRef.util'

// "customFactor:<name>" is this domain's own sentinel prefix — distinct from every other
// requirement prefix — so a raw policyBody value is unambiguous about which kind of requirement it
// diverts to.
export const REQUIREMENT_REF_PREFIX = CUSTOM_AUTHENTICATION_FACTOR_REQUIREMENT_REF_PREFIX

export const isRequirementRef = (value) => typeof value === 'string' && value.startsWith(REQUIREMENT_REF_PREFIX)

export const getRequirementId = (value) => (isRequirementRef(value) ? value.slice(REQUIREMENT_REF_PREFIX.length) : null)

export const toRequirementRef = (requirementId) => `${REQUIREMENT_REF_PREFIX}${requirementId}`

// Mirrors backend/src/lambdas/service/hub/microsoft/customAuthenticationFactorRequirements/
// resolveCustomAuthenticationFactorRequirements.js's RESOLUTION_STATUS. Augmentt doesn't create
// custom controls, so a name that finds no single match is unresolvable.
export const CUSTOM_AUTHENTICATION_FACTOR_REQUIREMENT_STATUS = {
  MATCHED: 'matched',
  UNRESOLVABLE: 'unresolvable',
  LOOKUP_FAILED: 'lookupFailed',
}
